import type { GridColDef } from "@mui/x-data-grid";
import type { DataGridProProps } from "@mui/x-data-grid-pro";

export const columnDataGridSettings: Partial<GridColDef> = {
  pinnable: false,
  filterable: false,
  resizable: false,
  hideable: false,
  disableColumnMenu: true,
  headerAlign: "center",
  align: "center",
};

export const dataGridSettings: Partial<DataGridProProps> = {
  sortingOrder: ["asc", "desc"],
  localeText: {
    columnMenuSortAsc: "Sort by ascending",
    columnMenuSortDesc: "Sort by descending",
  },
};
